import { Component, OnInit, Inject, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, AbstractControl, Validators } from '@angular/forms';
import { EcmToolChangeService } from '../ecm-tool-change.service';
import { CgpAlertDialogService, cgpAlertTypes } from 'src/app/shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { UserService } from '../../../../../../modules/user.service';

@Component({
  selector: 'etc-edit-tool-change',
  templateUrl: './etc-edit-tool-change.component.html',
  styleUrls: ['./etc-edit-tool-change.component.scss']
})
export class EtcEditToolChangeComponent implements OnInit, OnDestroy {

  @ViewChild('toolChangeTable') toolChangeTable: DataTableComponent;

  readonly NEC_LEC_MIN_LENGTH = 1;
  readonly NEC_LEC_MAX_LENGTH = 7;
  readonly NEC_LEC_REGEX = /^(REL|\(REL\)|\(REL|REL\)|[A-Z][A-Z]?)$/i;

  designSources: any[];
  loading = false;
  private readonly _subs: Subscription[] = [];
  isShippedToDataBank = false;
  usedNecLec: any[];
  toolChangeId: any;
  toolId: any;
  selections: any;
  isNew: boolean;
  editToolChangeForm = new UntypedFormGroup({
    necLec: new UntypedFormControl('', [Validators.pattern(this.NEC_LEC_REGEX)]),
    tlLeadRelLvl: new UntypedFormControl(''),
    certDataAffected: new UntypedFormControl(false),
    toolAffected: new UntypedFormControl(false),
    dtShippedToDatabank: new UntypedFormControl(''),
    necCompleteDate: new UntypedFormControl(''),
    designSourceId: new UntypedFormControl(this.user.UserProfile.userSourceId),
    toolId: new UntypedFormControl(''),
  });

  constructor(
    public readonly dialogRef: MatDialogRef<EtcEditToolChangeComponent>,
    private readonly fb: UntypedFormBuilder,
    private readonly ecmToolChangeService: EcmToolChangeService,
    private readonly cgpAlertDialogService: CgpAlertDialogService,
    private readonly user: UserService,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) { }

  ngOnInit() {
    this.designSources = this.data.designSources;
    const selected = this.data.selected;
    this.toolChangeId = selected ? selected.toolChangeId : '';
    this.usedNecLec = this.data.usedNecLec;
    this.toolId = selected ? selected.toolId : this.data.toolId;
    this.isNew = this.data.isNew;
    if (!this.isNew) {
      this.editToolChangeForm = this.fb.group({
        necLec: [selected.necLec, [Validators.pattern(this.NEC_LEC_REGEX)]],
        tlLeadRelLvl: [selected.tlLeadRelLvl],
        certDataAffected: [selected.certDataAffected],
        toolAffected: [selected.toolAffected],
        dtShippedToDatabank: [selected.dtShippedToDatabank],
        necCompleteDate: [selected.necCompleteDate],
        designSourceId: [selected.designSourceId]
      });
    }

    if (this.editToolChangeForm.get('dtShippedToDatabank').value) {
      this.editToolChangeForm.get('necLec').disable();
      this.editToolChangeForm.get('tlLeadRelLvl').disable();
      this.editToolChangeForm.get('certDataAffected').disable();
      this.editToolChangeForm.get('toolAffected').disable();
      this.editToolChangeForm.get('necCompleteDate').enable();
    }

    if (this.editToolChangeForm.get('tlLeadRelLvl').value === null || this.editToolChangeForm.get('tlLeadRelLvl').value === ''
      || this.editToolChangeForm.get('designSourceId').value == null || this.editToolChangeForm.get('designSourceId').value === '') {
      this.editToolChangeForm.get('dtShippedToDatabank').disable();
    }
    if (!this.editToolChangeForm.get('dtShippedToDatabank').value) {
      this.editToolChangeForm.get('necCompleteDate').disable();
      this.editToolChangeForm.get('necLec').enable();
      this.editToolChangeForm.get('tlLeadRelLvl').enable();
      this.editToolChangeForm.get('certDataAffected').enable();
      this.editToolChangeForm.get('toolAffected').enable();
    }
  }

  ngOnDestroy() {
    this._subs.forEach(sub => sub.unsubscribe());
  }

  disableEnableFormField(necComplDate: any, event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.editToolChangeForm.get('necLec').disable();
      this.editToolChangeForm.get('tlLeadRelLvl').disable();
      this.editToolChangeForm.get('certDataAffected').disable();
      this.editToolChangeForm.get('toolAffected').disable();
      this.editToolChangeForm.get('necCompleteDate').enable();
    }
    else if (!event.value && necComplDate.value) {
      const ref = this.cgpAlertDialogService.showAlertDialog({
        message: 'Removing the Shipped to Databank Date will also remove the NEC Complete Date'
      });
      ref.afterClosed().subscribe(() => {
        this.editToolChangeForm.get('necCompleteDate').disable();
        this.editToolChangeForm.get('necCompleteDate').reset();
        this.editToolChangeForm.get('necLec').enable();
        this.editToolChangeForm.get('tlLeadRelLvl').enable();
        this.editToolChangeForm.get('certDataAffected').enable();
        this.editToolChangeForm.get('toolAffected').enable();
      });

    }
    else {
      this.editToolChangeForm.get('necLec').enable();
      this.editToolChangeForm.get('tlLeadRelLvl').enable();
      this.editToolChangeForm.get('certDataAffected').enable();
      this.editToolChangeForm.get('toolAffected').enable();
      this.editToolChangeForm.get('necCompleteDate').disable();
      this.editToolChangeForm.get('necCompleteDate').reset();
    }
  }


  enableDisableShippedtoDateBank(event: any) {
    if ((this.editToolChangeForm.get('tlLeadRelLvl').value !== null && this.editToolChangeForm.get('tlLeadRelLvl').value !== '')
      && (this.editToolChangeForm.get('designSourceId').value !== null && this.editToolChangeForm.get('designSourceId').value !== '')) {
      this.editToolChangeForm.get('dtShippedToDatabank').enable();
    } else {
      this.editToolChangeForm.get('dtShippedToDatabank').disable();
    }
  }

  getNecLecInformation(): string {
    if (this.editToolChangeForm.get('dtShippedToDatabank').value) {
      return 'You cannot enter NEC LEC after entering the Shipped to Databank Date ';
    } else {
      return 'Notification Engineering Change LEC - Required before entering the Shipped to Databank Date. ';
    }
    return 'Notification Engineering Change LEC - Required before entering the Shipped to Databank Date. \n \n You cannot check this Tool Change after you have entered the Shipped to Databank Date ';
  }

  getToolAffectedInformation(): string {
    if (this.editToolChangeForm.get('dtShippedToDatabank').value) {
      return 'You cannot check/uncheck this after entering the Shipped to Databank Date ';
    } else {
      return 'Check this box to identify the Tool as being affected - Required before entering the Shipped to Databank Date. ';
    }
  }

  getCertDataAffectedInformation(): string {
    if (this.editToolChangeForm.get('dtShippedToDatabank').value) {
      return 'You cannot check/uncheck this after entering the Shipped to Databank Date ';
    } else {
      return 'Check this box to identify there is Certification Data - Required before entering the Shipped to Databank Date. ';
    }
  }

  getTlLeadRelLvlInformation(): string {
    if (this.editToolChangeForm.get('dtShippedToDatabank').value) {
      return 'You cannot enter TL Lead Rel Lvl after entering the Shipped to Databank Date ';
    } else {
      return 'Tool Lead Release Level - Required before entering the Shipped to Databank Date.';
    }
  }

  isNecLecValid(neclec: any) {
    const oldNecLec = this.data.selected ? this.data.selected.necLec : '';
    if (this.usedNecLec.length !== 0) {
      this.usedNecLec.forEach(val => {
        if (neclec === val) {
          const ref = this.cgpAlertDialogService.showAlertDialog({
            message: 'Nec "' + neclec.toUpperCase() + '" has been databanked and can no longer be used. Try again.'
          });
          ref.afterClosed().subscribe(() => {
            this.editToolChangeForm.get('necLec').setValue(this.isNew ? '' : oldNecLec);
          });
        }
      });
    }
  }

  onUpdateClick() {
    this.loading = true;
    this.editToolChangeForm.get('necLec').enable();
    this.editToolChangeForm.get('tlLeadRelLvl').enable();
    this.editToolChangeForm.get('certDataAffected').enable();
    this.editToolChangeForm.get('toolAffected').enable();
    this.editToolChangeForm.get('necCompleteDate').enable();
    this.editToolChangeForm.get('dtShippedToDatabank').enable();
    const body = this.createBody();
    (this.isNew ?
      this.ecmToolChangeService.addEcmToolChange.bind(this.ecmToolChangeService) :
      this.ecmToolChangeService.updateToolChange.bind(this.ecmToolChangeService)
    )(body).subscribe({
      next: () => {
        this.cgpAlertDialogService.showAlertDialog({
          title: this.isNew ? 'Add Tool Change Complete' : 'Update Complete',
          message: 'Changes successful!',
          alert: cgpAlertTypes.success,
          closeLabel: 'Close'
        }).afterClosed().subscribe(() => this.dialogRef.close({
          reload: true,
          toolChangeId: this.isNew ? '' : this.toolChangeId
        }));
      },
      error: () => {
        this.cgpAlertDialogService.showAlertDialog({
          title: this.isNew ? 'Add Tool Change Failed' : 'Update Tool Change Failed',
          message: 'Changes unsuccessful! Please try again.',
          alert: cgpAlertTypes.danger,
          closeLabel: 'Close'
        }).afterClosed().subscribe({ complete: () => this.loading = false });
      }
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  private convertValues(formData, body) {
    // Iterate through the formData and:
    // convert boolean values into expected number values
    // convert date values into expected date ISO string value
    Object.keys(formData).forEach(
      (el) => {
        if (typeof formData[el] === 'boolean') {
          body[el] = (formData[el]) ? 1 : 0;
        } else {
          body[el] = formData[el];
        }
      }
    );
  }

  private updateIsNew(formData, body, designSource) {
    body['sourceName'] = (designSource) ? designSource.sourceName : '';
    if (formData.necLec !== null) {
      body['necLec'] = body['necLec'] === 'REL' ? '(REL)' : body['necLec'].toString().toUpperCase();
    }
    if (formData.tlLeadRelLvl !== null) {
      body['tlLeadRelLvl'] = body['tlLeadRelLvl'].toString().toUpperCase();
    }
    body['toolId'] = this.toolId;
  }

  private updateIsNotNew(formData, body, designSource) {
    body['designSourceId'] = (designSource) ? designSource.id : '';
    if (formData.necLec !== null) {
      body['necLec'] = (body['necLec'] === 'REL' || body['necLec'] === '(REL' || body['necLec'] === 'REL)'
        || body['necLec'] === 'rel' || body['necLec'] === '(rel' || body['necLec'] === 'rel)')
        ? '(REL)' : (body['necLec'] ? body['necLec'].toString().toUpperCase() : body['necLec']);
    }
    if (formData.tlLeadRelLvl !== null) {
      body['tlLeadRelLvl'] = body['tlLeadRelLvl'].toString().toUpperCase();
    }
  }

  private updateBody(formData, body) {

    const designSource = this.designSources.find(el => el.id === this.editToolChangeForm.value.designSourceId);
    // Append the toolChangeIds from the tool change selection before
    // opening the multi-row edit dialog
    if (this.isNew) {
      this.updateIsNew(formData, body, designSource);
    } else {
      this.updateIsNotNew(formData, body, designSource);
    }
  }

  private createBody() {
    const data = this.data.selected;
    const body = {};
    const formData = this.editToolChangeForm.value;

    this.convertValues(formData, body);
    this.updateBody(formData, body);

    return this.isNew ? body : {
      ...body,
      toolChangeId: data.toolChangeId,
      addedBy: data.addedBy,
      approvalDate: data.approvalDate,
      authNumber: data.authNumber,
      authNumberN: data.authNumberN,
      authTypeName: data.authTypeName,
      dupCheckId: data.dupCheckId,
      fmtAddedDate: data.fmtAddedDate,
      fmtCompleteDate: data.fmtCompleteDate,
      fmtLastUpdatedDate: data.fmtLastUpdatedDate,
      fmtNecCompleteDate: data.fmtNecCompleteDate,
      fmtReleaseLevel: data.fmtReleaseLevel,
      fmtdtShippedToDatabank: data.fmtdtShippedToDatabank,
      lastUpdatedBy: data.lastUpdatedBy,
      lhStablePartCode: data.lhStablePartCode,
      oppositePart: data.oppositePart,
      partChangeId: data.partChangeId,
      partNumber: data.partNumber,
      partType: data.partType,
      pdi: data.pdi,
      programName: data.programName,
      releaseLevel: data.releaseLevel,
      rhStablePartCode: data.rhStablePartCode,
      toolId: data.toolId
    };
  }

}

